// general functions used in different actions files

export function imageAlreadyLoaded(image, prefix) {
  return image[prefix + "HtmlObject"] || image[prefix + "IsLoading"] || image[prefix + "NotFound"];
}